"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectDataSection = void 0;
const types_1 = require("../../../types");
exports.projectDataSection = {
    label: "form.project.label",
    name: "projectdata",
    subline: "form.project.subline",
    fields: [
        {
            name: "product_name",
            label: "form.project.productName",
            type: types_1.FormFieldType.full,
            required: true,
            placeholder: "form.project.placeholder.productName",
        },
        {
            name: "type",
            label: "form.project.type",
            type: types_1.FormFieldType.input,
            placeholder: "form.project.placeholder.type",
        },
        {
            name: "serial_number",
            label: "form.project.serialNumber",
            type: types_1.FormFieldType.input,
            required: true,
            placeholder: "form.project.placeholder.serialNumber",
        },
        {
            name: "inventory_number",
            label: "form.project.inventoryNumber",
            type: types_1.FormFieldType.input,
            placeholder: "form.project.placeholder.inventoryNumber",
        },
        {
            name: "launch_date",
            label: "form.project.launchDate",
            type: types_1.FormFieldType.date,
            required: true,
        },
        {
            name: "description",
            label: "form.project.description",
            type: types_1.FormFieldType.area,
            required: true,
            placeholder: "form.project.placeholder.description",
        },
        {
            name: "main_product_image",
            label: "form.project.main_product_image",
            info: "form.project.main_product_image.info",
            type: types_1.FormFieldType.upload,
            required: true,
        },
    ],
};
exports.default = exports.projectDataSection;
